export default {
  install(Vue) {
    Vue.prototype.$_globalMixin_isValidUuid = function(value) {
      // 18ff5f9b-1a22-43d7-a36e-ae7592df09f7
      // BE RegexExp ^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

      return regexExp.test(value);
    };
  }
};
